import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import { type IncomeProtectionStepParams, illnessSchema } from './types'

export const illness = (params: IncomeProtectionStepParams) => {
  const schema = illnessSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_incomeProtection:steps.illness.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_occupational_disability_de.shape.configuration_parameters.shape.illness.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_incomeProtection:steps.illness.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('illness'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'login',
    subFlow: SubFlow.IncomeProtection,
  } as const satisfies AnyStepConfiguration
}
